

precision highp float;
precision highp int;
precision highp sampler2D;

in vec2 vUv;
out vec4 fragColor;

void main() {
  fragColor = vec4(1., 0., 0., 1.);
}